<template>
  <section class="container" id="about">
    <div class="grid-two">
      <div>
        <a
          href="https://github.com/faisalamin001"
          rel="noopener"
          aria-label="Github"
          title="faisal"
        >
          <div class="profile-img"></div>
        </a>
      </div>
      <div class="introduction">
        <h4>About Me</h4>
        <p>
          I graduated from Edwardes College with a degree in Computer
          Science.This journey has been a continuous exploration of the digital
          realm. With <span> 2 </span> years of professional experience, I've
          honed my skills as a Full Stack Engineer. I excel at crafting and
          architecting applications, covering both Front-end interfaces and
          robust Back-end systems. I've had the opportunity to contribute to
          projects that push technology's boundaries, reaffirming my commitment
          to excellence in development.
        </p>
        <br />
        <p>
          Outside of my professional endeavors, I find joy in a trifecta of
          hobbies. Reading, especially novels and self-help literature, fuels my
          curiosity and provides a window to different worlds and perspectives.
          Football, on the other hand, is where I channel my competitive spirit
          and love for teamwork. When I'm not on the field, I'm often exploring
          the great outdoors, indulging in hiking.
        </p>

        <!-- <picture v-if="darkTheme">
          <source
            srcset="../assets/images/quote-1-white.webp"
            type="image/webp"
          />
          <source
            srcset="../assets/images/quote-1-white.png"
            type="image/jpeg"
          />
          <img
            class="quote-1"
            src="../assets/images/quote-1-white.png"
            alt="Quotes 1"
          />
        </picture>

        <picture v-if="!darkTheme">
          <source srcset="../assets/images/quote-1.webp" type="image/webp" />
          <source srcset="../assets/images/quote-1.png" type="image/jpeg" />
          <img
            class="quote-1"
            src="../assets/images/quote-1.png"
            alt="Quotes 1"
          />
        </picture> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About',
  computed: {
    darkTheme() {
      return this.$store.state.darkTheme;
    },
  },
};
</script>

<style></style>
